import React from 'react';
import Navigation from './navigation/Navigation';

import './App.scss';

export default (): JSX.Element => {
  return <Navigation />;
};
